import {defineStore} from 'pinia';
import {getOrderTypes} from '../api.js';

export const useOrderStore = defineStore('order', {
    state: () => ({
        order_types: [],
        loading: false,
        error: null
    }),
    actions: {
        async fetchOrderTypes() {
            this.loading = true;
            this.error = null;
            try {
                const data = await getOrderTypes();
                this.order_types = data.data;
            } catch (err) {
                this.error = err;
            } finally {
                this.loading = false;
            }
        }
    },
    getters: {
        getOrderFromId: (state) => (typeId) => {
            const orderType = state.order_types.find(type => type.id === Number(typeId));
            return orderType ? orderType : null;
        },
        getOrdersForCreate: (state) => () => {
            const items = state.order_types.filter(type => {
               return !type.is_return && type.code !== 'send-brand'
            } );
            return items;
        }
    }
});
